module.exports = __webpack_public_path__ + "img/outlook.b765472b.png";